import { useQueryParams } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface ProfileNameFilterProps {
  profileNameOptions: { id: string; name: string }[];
}

export function ProfileNameFilter(props: ProfileNameFilterProps) {
  const { t } = useTranslation();
  const { setParam, flatParams } = useQueryParams();
  const filterKey = "profile_ids";

  return (
    <Picker
      showActionBar
      selectedKeys={
        flatParams[filterKey]
          ? flatParams[filterKey].split(",").filter(Boolean)
          : []
      }
      onSelectionChange={(keys) => {
        setParam(filterKey, Array.from(keys).map(String), true);
      }}
      label={t("Profile name")}
      items={props.profileNameOptions}
      selectionMode="multiple"
      testID="profile-name-filter"
    />
  );
}
